export class ForbiddenError {
    message?: string;

    constructor(message?: string) {
        this.message = message;
    }
}
